// extracted by mini-css-extract-plugin
module.exports = {"root":"TextSection_root__108Qo","article":"TextSection_article__4Kqpm","label":"TextSection_label__3WtQH","heading":"TextSection_heading__11hWm"};